<template>
    <main>
        <div class="graphics-box graphics-box--01 rellax" data-rellax-speed="2"></div>
        <div>
            <div class="table_intro">
                <h2 v-if="discount" class="plan_table_text_title page-top__title">
                    {{ $t('pt_title') }} <br />
                    {{ $t('pt_title_limited') }}
                    <span class="discount_text">{{ $t('pt_discount_badge') }}</span>
                </h2>
                <h2 v-else class="plan_table_text_title page-top__title">
                    {{ $t('pt_title_no_discount') }}
                </h2>
                <p v-if="discount" class="plan_table_text_subtitle" v-html="$t('pt_discount_p')"></p>
                <p v-else class="plan_table_text_subtitle">
                    <span class="highlight_text">1580</span> {{ $t('pt_stats_1') }}
                    <span class="highlight_text"><span id="rideCounter">0</span>+</span>
                    {{ $t('pt_stats_2') }}
                </p>
                <div v-if="success" class="
                    after_success_payment_message mt-5 main-width bg-subscription-green_light rounded-6px 
                    mx-auto h-56px pl-20px
                    flex items-center gap-14px mb-10px border-1 border-subscription-green border-solid">
                    <i i-app-check w-20px h-20px />
                    <div class="text-14px font-400 text-subscription-green_dark" v-html="$t('pt_success_msg')">
                    </div>
                </div>
                <div v-if="discount && !is_logged_in" class="have_to_be_logged_in">
                    <div flex gap-10px>
                        <i i-app-info class="h-20px w-20px" />
                        <p v-html="$t('pt_login_required')"></p>
                    </div>
                    <a href="/prihlasenie">{{ $t('pt_login_link') }}</a>
                </div>
                <div v-if="!discount" class="plan_table_text_check_wrapper">
                    <div class="plan_table_text_check">
                        <svg width="17" height="12" viewBox="0 0 17 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1.14575 7L5.13558 11L15.1102 1" stroke="#34D399" stroke-width="2"
                                stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        <span>{{ $t('pt_benefit_1') }}</span>
                    </div>
                    <div class="plan_table_text_check">
                        <svg width="17" height="12" viewBox="0 0 17 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1.14575 7L5.13558 11L15.1102 1" stroke="#34D399" stroke-width="2"
                                stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        <span>{{ $t('pt_benefit_2') }}</span>
                    </div>
                </div>
            </div>

            <div v-if="!discount" class="toggle-container" :style="toggleContainerStyle">
                <button :class="{ active: billingCycle === 'yearly' }" @click="setBillingCycle('yearly')">
                    <div class="toggle-discount">
                        <span>{{ $t('pt_yearly') }}</span>
                        <span class="discount-box">{{ $t('pt_discount_pct') }}</span>
                    </div>
                </button>
                <button :class="{ active: billingCycle === 'monthly' }" @click="setBillingCycle('monthly')">
                    {{ $t('pt_monthly') }}
                </button>
            </div>

            <div v-if="!is_logged_in" class="toggle-container2 text-16px font-600 text-center text-[#F93C34] mb-40px">
                {{ $t('pt_trial_info') }}
            </div>

            <div class="pricing-layout">
                <div class="features-column">
                    <div v-for="(feature, index) in features" :key="index"
                        :class="['feature-item', { disabled: Boolean(feature.disabled) }]">
                        {{ feature.name }}
                    </div>
                    <div class="feature-item price-per-month">{{ $t('pt_price_per_month') }}</div>
                </div>
                <div class="pricing-container">
                    <div v-for="(plan, index) in pricingPlans" :key="index"
                        :class="['pricing-card', { popular: Boolean(plan.top) }]">
                        <div>
                            <div v-if="Boolean(plan.top)" class="top_badge">TOP</div>
                            <h2>{{ plan.name.toUpperCase() }}</h2>
                            <div class="features-container">
                                <div v-for="(feature, fIndex) in filteredFeatures(plan)" :key="fIndex"
                                    class="feature-status">
                                    <span v-if="plan.features[fIndex] === true">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                                            fill="currentColor" class="bi bi-check-circle-fill" viewBox="0 0 16 16">
                                            <path
                                                d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                                        </svg>
                                    </span>
                                    <span v-else-if="plan.features[fIndex]">{{
                                        plan.features[fIndex]
                                        }}</span>
                                </div>
                            </div>
                        </div>
                        <div>
                            <div :key="billingCycle" class="price" flex gap-10px justify-center>
                                <div v-if="discount && plan.yearlyPrice != 0" flex items-center>
                                    <span class="discount-price">
                                        {{
                                            billingCycle === 'yearly' ? Math.floor(plan.yearlyPrice) :
                                                Math.floor(plan.monthlyPrice)
                                        }}
                                    </span>
                                    <sup class="discount-price">
                                        {{
                                            ((billingCycle === 'yearly' ? plan.yearlyPrice : plan.monthlyPrice) %
                                                1).toFixed(2).substring(2)
                                                !==
                                                '00'
                                                ? ((billingCycle === 'yearly' ? plan.yearlyPrice : plan.monthlyPrice) %
                                                    1).toFixed(2).substring(2)
                                                : ''
                                        }} {{ $currency.symbol }}
                                    </sup>
                                </div>
                                <div v-if="discount">
                                    <span>
                                        {{
                                            billingCycle === 'yearly' ? Math.floor(plan.yearlyPriceDiscount) :
                                                Math.floor(plan.monthlyPriceDiscount)
                                        }}
                                    </span>
                                    <sup>
                                        {{
                                            ((billingCycle === 'yearly' ? plan.yearlyPriceDiscount :
                                                plan.monthlyPriceDiscount) %
                                                1).toFixed(2).substring(2) !==
                                                '00'
                                                ? ((billingCycle === 'yearly' ? plan.yearlyPriceDiscount :
                                                    plan.monthlyPriceDiscount) %
                                                    1).toFixed(2).substring(2)
                                                : ''
                                        }}
                                    </sup>{{ $currency.symbol }}
                                </div>
                                <div v-else>
                                    <span>
                                        {{
                                            billingCycle === 'yearly' ? Math.floor(plan.yearlyPrice) :
                                                Math.floor(plan.monthlyPrice)
                                        }}
                                    </span>
                                    <sup>
                                        {{
                                            ((billingCycle === 'yearly' ? plan.yearlyPrice : plan.monthlyPrice) %
                                                1).toFixed(2).substring(2)
                                                !==
                                                '00'
                                                ? ((billingCycle === 'yearly' ? plan.yearlyPrice : plan.monthlyPrice) %
                                                    1).toFixed(2).substring(2)
                                                : ''
                                        }}
                                    </sup>{{ $currency.symbol }}
                                </div>
                            </div>
                            <a class="table_plan_btn" @click="createCheckoutSession(plan)">
                                <div v-if="plan.buttonArrow && !isPlanActive(plan)" class="arrow_right">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22"
                                        fill="none">
                                        <path
                                            d="M19.25 10.9999H2.75M12.8333 4.58325L19.25 10.9999L12.8333 4.58325ZM19.25 10.9999L12.8333 17.4166L19.25 10.9999Z"
                                            stroke="#F93C34" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </div>
                                <!-- <div v-if="discount" class="z-10 relative inline-block">
                                    <span class="uppercase cursor-pointer">
                                        {{ plan.buttonDiscount }}
                                    </span>
                                    <div v-if="!is_logged_in"
                                        :class="['tooltip opacity-0  absolute bottom-[-70px] t transform -translate-x-1/2 z-10 w-max max-w-[300px]',
                                            { 'left-180px ': plan.yearlyPrice > 7.9, 'left--40px': plan.yearlyPrice <= 7.9 }]">
                                        <div
                                            class="border border-gray-200 bg-white text-center text-gray-800 font-400 text-left py-3 px-4 rounded-xl text-sm shadow-lg whitespace-normal">
                                            Pre zakúpenie balíčku so zľavou je potrebné sa prihlásiť
                                        </div>
                                    </div>
                                </div> -->
                                <span v-if="!isPlanActive(plan)" style="text-transform: uppercase;">
                                    {{ plan.buttonText }}
                                </span>
                                <span v-else style="text-transform: uppercase;">
                                    {{ $t('pt_active_plan') }}
                                </span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <div class="mobile-pricing-layout">
                <div class="mobile-pricing-tabs">
                    <div v-for="(plan, index) in pricingPlans" :key="index"
                        :class="['tab-item', { 'active-tab': activeIndex === index }]" @click="goToSlide(index)">
                        {{ plan.name }}
                    </div>
                </div>

                <div class="swiper-container pricing-carousel-wrapper">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide pricing-card" v-for="(plan, index) in pricingPlansMobile" :key="index">
                            <div>
                                <h2>{{ plan.name.toUpperCase() }}</h2>
                                <div :key="billingCycle" class="price" flex gap-10px justify-center style="margin-top: 0px;">
                                    <div v-if="discount && plan.yearlyPrice != 0" flex items-center>
                                        <span class="discount-price">
                                            {{
                                                billingCycle === 'yearly' ? Math.floor(plan.yearlyPrice) :
                                                    Math.floor(plan.monthlyPrice)
                                            }}
                                        </span>
                                        <sup class="discount-price">
                                            {{
                                                ((billingCycle === 'yearly' ? plan.yearlyPrice : plan.monthlyPrice) %
                                                    1).toFixed(2).substring(2)
                                                    !==
                                                    '00'
                                                    ? ((billingCycle === 'yearly' ? plan.yearlyPrice : plan.monthlyPrice) %
                                                        1).toFixed(2).substring(2)
                                                    : ''
                                            }} {{ $currency.symbol }}
                                        </sup>
                                    </div>
                                    <div v-if="discount">
                                        <span>
                                            {{
                                                billingCycle === 'yearly' ? Math.floor(plan.yearlyPriceDiscount) :
                                                    Math.floor(plan.monthlyPriceDiscount)
                                            }}
                                        </span>
                                        <sup>
                                            {{
                                                ((billingCycle === 'yearly' ? plan.yearlyPriceDiscount :
                                                    plan.monthlyPriceDiscount) %
                                                    1).toFixed(2).substring(2) !==
                                                    '00'
                                                    ? ((billingCycle === 'yearly' ? plan.yearlyPriceDiscount :
                                                        plan.monthlyPriceDiscount) %
                                                        1).toFixed(2).substring(2)
                                                    : ''
                                            }}
                                        </sup>{{ $currency.symbol }}
                                    </div>
                                    <div v-else>
                                        <span>
                                            {{
                                                billingCycle === 'yearly' ? Math.floor(plan.yearlyPrice) :
                                                    Math.floor(plan.monthlyPrice)
                                            }}
                                        </span>
                                        <sup>
                                            {{
                                                ((billingCycle === 'yearly' ? plan.yearlyPrice : plan.monthlyPrice) %
                                                    1).toFixed(2).substring(2)
                                                    !==
                                                    '00'
                                                    ? ((billingCycle === 'yearly' ? plan.yearlyPrice : plan.monthlyPrice) %
                                                        1).toFixed(2).substring(2)
                                                    : ''
                                            }}
                                        </sup>{{ $currency.symbol }}
                                    </div>
                                </div>
                                <div class="mobile-features-container">
                                    <div v-for="(feature, fIndex) in filteredFeatures(plan)" :key="fIndex" :class="[
                                        'mobile-feature-status',
                                        {
                                            disabled: Boolean(feature.disabled),
                                        },
                                    ]">
                                        <span v-if="plan.features[fIndex]">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                                                fill="currentColor" class="bi bi-check-circle-fill" viewBox="0 0 16 16">
                                                <path
                                                    d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                                            </svg>
                                        </span>
                                        {{
                                            plan.features[fIndex] === true
                                                ? features[fIndex].name
                                                : null
                                        }}
                                        {{
                                            plan.features[fIndex] !== true && plan.features[fIndex]
                                                ? plan.features[fIndex]
                                                : null
                                        }}
                                    </div>
                                </div>
                            </div>
                            <div> 
                                <a class="table_plan_btn" @click="createCheckoutSession(plan)">
                                    <div v-if="plan.buttonArrow" class="arrow_right">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22"
                                            viewBox="0 0 22 22" fill="none">
                                            <path
                                                d="M19.25 10.9999H2.75M12.8333 4.58325L19.25 10.9999L12.8333 4.58325ZM19.25 10.9999L12.8333 17.4166L19.25 10.9999Z"
                                                stroke="#F93C34" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </div>
                                    <!-- <div v-if="discount" class="z-10 relative inline-block">
                                        <span class="uppercase cursor-pointer">
                                            {{ plan.buttonDiscount }}
                                        </span>
                                        <div v-if="!is_logged_in"
                                            :class="['tooltip opacity-0  absolute bottom-[-70px] t transform -translate-x-1/2 z-10 w-max max-w-[300px]',
                                                { 'left-180px ': plan.yearlyPrice > 7.9, 'left--40px': plan.yearlyPrice <= 7.9 }]">
                                            <div
                                                class="border border-gray-200 bg-white text-center text-gray-800 font-400 text-left py-3 px-4 rounded-xl text-sm shadow-lg whitespace-normal">
                                                Pre zakúpenie balíčku so zľavou je potrebné sa prihlásiť
                                            </div>
                                        </div>
                                    </div> -->
                                    <span v-if="!isPlanActive(plan)" style="text-transform: uppercase;">
                                        {{ plan.buttonText }}
                                    </span>
                                    <span v-else style="text-transform: uppercase;">
                                        {{ $t('pt_active_plan') }}
                                    </span>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="swiper-pagination"></div>
                </div>
            </div>

            <div class="table_outro">
                <h2 class="title">{{ $t('pt_outro_title', { price: outroPrice(discount) }) }}</h2>
                <button class="link" id="compare-features-button">
                    <span>{{ $t('pt_compare_features') }}</span>
                    <div class="arrow_right">
                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                            <path
                                d="M19.25 10.9999H2.75M12.8333 4.58325L19.25 10.9999L12.8333 4.58325ZM19.25 10.9999L12.8333 17.4166L19.25 10.9999Z"
                                stroke="#F93C34" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </div>
                </button>
            </div>
        </div>
    </main>
</template>

<script>
import { EventBus } from "@/eventBus";

export default {
    props: {
        activePlan: {
            type: String,
            default: 'Zadarmo',
        },
        paymentType: {
            type: String,
            default: "monthly",
        },
        is_paid: {
            type: Number,
            default: 0,
        },
        userCount: {
            type: Number,
            default: 2000,
        },
        discount: {
            type: Boolean | Number,
            default: false,
        },
        is_logged_in: {
            type: Boolean | Number,
            default: false,
        },
        success: {
            type: Boolean | Number,
            default: false,
        },
        user_id: {
            type: Number,
            default: null,
        },
        session_id: {
            type: String,
            default: null,
        },
        register_status: {
            type: Boolean | Number,
            default: false,
        },
    },
    data() {
        // Cennik ceny zo single source (plan_prices cez window.__PRICING__), s fallbackom
        // na povodne hodnoty (aby pri chybajucej injekcii ostalo spravanie 1:1).
        const __P = (typeof window !== 'undefined' && window.__PRICING__) || {};
        const price = (key, period, fallback) => (__P[key] && __P[key][period] != null) ? Number(__P[key][period]) : fallback;
        return {
            billingCycle: "yearly",
            activeIndex: 0,
            pricingSwiper: null,
            showTooltip: false,
            pricingPlans: [
                {
                    name: this.$t('pt_plan_free'),
                    top: false,
                    monthID: 10,
                    yearID: 10,
                    monthlyPrice: price('free', 'month', 0),
                    yearlyPrice: price('free', 'year', 0),
                    yearlyPriceDiscount: 0,
                    features: ["max 3", "max 3", "", "", "", "", "", "", "", "", "", ""],
                    buttonText: !this.is_logged_in ? this.$t('pt_btn_register') : this.$t('pt_btn_choose'),
                    buttonDiscount: this.$t('pt_btn_your_plan'),
                    buttonArrow: this.is_logged_in == 1 ? true : false,
                },
                {
                    name: this.$t('pt_plan_profi'),
                    top: false,
                    monthID: 14,
                    yearID: 13,
                    monthlyPrice: price('profi', 'month', 9.99),
                    yearlyPrice: price('profi', 'year', 7.99),
                    yearlyPriceDiscount: price('profi', 'year', 7.99) / 2,
                    features: [true, true, true, true, true, true, "", "", "", "", "", ""],
                    buttonText: !this.is_logged_in ? this.$t('pt_btn_try_free') : this.$t('pt_btn_choose'),
                    buttonDiscount: this.$t('pt_btn_pay_discount'),
                    buttonArrow: true,
                },
                {
                    name: this.$t('pt_plan_small'),
                    top: true,
                    monthID: 16,
                    yearID: 15,
                    monthlyPrice: price('small', 'month', 19.99),
                    yearlyPrice: price('small', 'year', 15.99),
                    yearlyPriceDiscount: price('small', 'year', 15.99) / 2,
                    features: [
                        true,
                        true,
                        true,
                        true,
                        true,
                        true,
                        "až 5",
                        true,
                        false,
                        true,
                        true,
                        true,
                        true,
                    ],
                    buttonText: !this.is_logged_in ? this.$t('pt_btn_try_free') : this.$t('pt_btn_choose'),
                    buttonDiscount: this.$t('pt_btn_pay_discount'),
                    buttonArrow: true,
                },
                {
                    name: this.$t('pt_plan_large'),
                    top: false,
                    monthID: 18,
                    yearID: 17,
                    monthlyPrice: price('large', 'month', 29.95),
                    yearlyPrice: price('large', 'year', 23.96),
                    yearlyPriceDiscount: price('large', 'year', 23.96) / 2,
                    features: [
                        true,
                        true,
                        true,
                        true,
                        true,
                        true,
                        "až 20",
                        true,
                        true,
                        true,
                        true,
                        true,
                    ],
                    buttonText: !this.is_logged_in ? this.$t('pt_btn_try_free') : this.$t('pt_btn_choose'),
                    buttonDiscount: this.$t('pt_btn_pay_discount'),
                    buttonArrow: true,
                },
            ],
            pricingPlansMobile: [
                {
                    name: this.$t('pt_plan_free'),
                    top: false,
                    monthID: 10,
                    yearID: 10,
                    monthlyPrice: price('free', 'month', 0),
                    yearlyPrice: price('free', 'year', 0),
                    yearlyPriceDiscount: 0,
                    features: [
                        this.$t('pt_max_3_clients'),
                        this.$t('pt_max_3_offers'),
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                    ],
                    buttonText: !this.is_logged_in ? this.$t('pt_btn_register') : this.$t('pt_btn_choose'),
                    buttonDiscount: this.$t('pt_btn_your_plan'),
                    buttonArrow: false,
                },
                {
                    name: this.$t('pt_plan_profi'),
                    top: false,
                    monthID: 14,
                    yearID: 13,
                    monthlyPrice: price('profi', 'month', 9.99),
                    yearlyPrice: price('profi', 'year', 7.99),
                    yearlyPriceDiscount: price('profi', 'year', 7.99) / 2,
                    features: [true, true, true, true, true, true, "", "", "", "", "", ""],
                    buttonText: !this.is_logged_in ? this.$t('pt_btn_try_free') : this.$t('pt_btn_choose'),
                    buttonDiscount: this.$t('pt_btn_pay_discount'),
                    buttonArrow: true,
                },
                {
                    name: this.$t('pt_plan_small'),
                    top: true,
                    monthID: 16,
                    yearID: 15,
                    monthlyPrice: price('small', 'month', 19.99),
                    yearlyPrice: price('small', 'year', 15.99),
                    yearlyPriceDiscount: price('small', 'year', 15.99) / 2,
                    features: [
                        true,
                        true,
                        true,
                        true,
                        true,
                        this.$t('pt_team_5'),
                        true,
                        false,
                        true,
                        true,
                        true,
                        true,
                    ],
                    buttonText: !this.is_logged_in ? this.$t('pt_btn_try_free') : this.$t('pt_btn_choose'),
                    buttonDiscount: this.$t('pt_btn_pay_discount'),
                    buttonArrow: true,
                },
                {
                    name: this.$t('pt_plan_large'),
                    top: false,
                    monthID: 18,
                    yearID: 17,
                    monthlyPrice: price('large', 'month', 29.95),
                    yearlyPrice: price('large', 'year', 23.96),
                    yearlyPriceDiscount: price('large', 'year', 23.96) / 2,
                    features: [
                        true,
                        true,
                        true,
                        true,
                        true,
                        this.$t('pt_team_20'),
                        true,
                        true,
                        true,
                        true,
                        true,
                    ],
                    buttonText: !this.is_logged_in == 1 ? this.$t('pt_btn_try_free') : this.$t('pt_btn_choose'),
                    buttonDiscount: this.$t('pt_btn_pay_discount'),
                    buttonArrow: true,
                },
            ],
            features: [
                { name: this.$t('pt_feat_unlimited_clients') },
                { name: this.$t('pt_feat_unlimited_offers') },
                { name: this.$t('pt_feat_hide_logo') },
                { name: this.$t('pt_feat_custom_colors') },
                { name: this.$t('pt_feat_stats_offers') },
                { name: this.$t('pt_feat_ai_desc') },
                { name: this.$t('pt_feat_team_accounts') },
                { name: this.$t('pt_feat_stats_sellers') },
                { name: this.$t('pt_feat_priority_support') },
                { name: this.$t('pt_feat_ai_offers'), disabled: true },
                { name: this.$t('pt_feat_variants'), disabled: true },
                { name: this.$t('pt_feat_margin'), disabled: true },
                { disabled: true },
            ],
        };
    },
    created() {
        EventBus.$on("billingCycleChanged", this.updateBillingCycle);
    },
    beforeDestroy() {
        EventBus.$off("billingCycleChanged", this.updateBillingCycle);
    },
    mounted() {
        // check if is #compare-features-list in url
        var counter = document.getElementById("rideCounter");
        var rideCounter = new countUp.CountUp(counter, this.userCount, {
            enableScrollSpy: true,
            scrollSpyOnce: true,
            scrollSpyDelay: 1000,
            duration: 5,
        });
        if (!rideCounter.error) {
            rideCounter.start();
        } else {
            console.error(rideCounter.error);
        }

        if (document.querySelector(".mobile-pricing-layout")) {
            this.pricingSwiper = new Swiper(".pricing-carousel-wrapper", {
                speed: 400,
                loop: false,
                slidesPerView: 1.2,
                spaceBetween: 15,
                centeredSlides: true,
                watchSlidesProgress: true,
                pagination: {
                    el: ".swiper-pagination",
                    type: "bullets",
                },
                on: {
                    slideChange: () => {
                        this.activeIndex = this.pricingSwiper.activeIndex;
                    },
                },
            });
        }
    },
    methods: {
        // Denná cena v outro. EUR: presné pôvodné marketingové hodnoty (nič nemeníme).
        // CZK: odvodená z najlacnejšieho plateného plánu (profi, ročná platba) — pekne v Kč.
        outroPrice(isDiscount) {
            if (!this.$currency || !this.$currency.isCzech()) {
                return (isDiscount ? '0,165' : '0,26') + (this.$currency ? this.$currency.symbol : '€');
            }
            const P = (typeof window !== 'undefined' && window.__PRICING__) || {};
            const profiYear = (P.profi && P.profi.year != null) ? Number(P.profi.year) : 200;
            const daily = profiYear * 12 / 365 * (isDiscount ? 0.5 : 1);
            return daily.toFixed(2).replace('.', ',') + ' ' + this.$currency.symbol;
        },
        cancelSubscription() {
            if(this.subscription_status == 'Zrušené'){
                this.$toast.error(this.$t('pt_subscription_cancelled'));
                return;
            }
            axios.post("/api/stripe/customer-portal-cancel", {
                user_id: this.user_id,
            })
            .then((response) => {
                window.location.href = response.data.url;
            });
        },
        changePlan(priceId, data = null) {
            // go to /admin/stripe/dashboard?invoice_details_alert=1
            // get plan from local storage
            if(data){
                localStorage.setItem('plan', JSON.stringify(data));
            }
            window.location.href = "/admin/subscriptions/dashboard?invoice_details_alert=1";
            return;
            axios.post("/api/stripe/customer-portal-switch-plan", {
                price_id: priceId,
                user_id: this.user_id,
            })
            .then((response) => {
                window.location.href = response.data.url;
            });
        },
        createCheckoutSession(plan) {

            let data = {
                plan: plan,
                billingCycle: this.billingCycle,
            }

            // is logged in
            if (this.is_logged_in != 0) {
                let priceId = this.billingCycle == 'yearly' ? plan.yearID : plan.monthID;
                // is paid
                if(this.is_paid == 1){
                    // is free plan
                    if(priceId == 10){
                        this.cancelSubscription();
                    }else{
                        // change plan
                        this.changePlan(priceId, data);
                    }
                    return;
                }
                // is free plan and not paid
                if(priceId == 10){
                    window.location.href = "/admin";
                    return;
                }
                if (this.register_status == 1) {
                    axios
                    .post("/api/stripe/create-checkout-session-without-payment", {
                        discount: sessionStorage.getItem('digiuni_discount') && this.billingCycle == 'yearly',
                        price_id: priceId,
                        user_id: this.user_id,
                    })
                    .then((response) => {
                        window.location.href = response.data.url;
                    });
                    return;
                }

                // store plan from local storage
                localStorage.setItem('plan', JSON.stringify(data));
                window.location.href = "/admin/subscriptions/dashboard?invoice_details_alert=1";
                return;
                axios
                    .post("/api/stripe/create-checkout-session", {
                        price_id: priceId,
                        user_id: this.user_id,
                        send_email: true,
                    })
                    .then((response) => {
                        window.location.href = response.data.url;
                    });
                // axios
                // .post("/api/stripe/create-checkout-session-without-payment", {
//                             discount: sessionStorage.getItem('digiuni_discount') && this.billingCycle == 'yearly',
                //     price_id: priceId,
                //     user_id: this.user_id,
                // })
                // .then((response) => {
                //     window.location.href = response.data.url;
                // });
                return;
                // continue in registration
            }
            // if is not logged in store to session and start registration
            localStorage.setItem('plan', JSON.stringify(data));
            window.location.href = "/register";
        },
        goToSlide(index) {
            if (this.pricingSwiper) {
                this.pricingSwiper.slideTo(index);
            }
            this.activeIndex = index;
        },
        setBillingCycle(cycle) {
            EventBus.$emit("billingCycleChanged", cycle);
        },
        updateBillingCycle(cycle) {
            this.billingCycle = cycle;
            gsap.fromTo(
                ".pricing-layout",
                { autoAlpha: 0, y: 30 },
                { autoAlpha: 1, y: 0, duration: 0.6, ease: "power2.out" }
            );
            gsap.fromTo(
                ".pricing-carousel-wrapper",
                { autoAlpha: 0, y: 30 },
                { autoAlpha: 1, y: 0, duration: 0.6, ease: "power2.out" }
            );
        },
    },
    computed: {
        isPlanActive() {
            return (plan) => {
                return plan.name === this.activePlan && this.paymentType === this.billingCycle;
            }
        },
        toggleContainerStyle() {
            return {
                margin: this.is_logged_in == 0 ? '0 auto 20px auto' : '30px auto 48px auto'
            };
        },
        filteredFeatures() {
            return (plan) => {
                return this.features.filter((feature, index) => {
                    return Boolean(
                        plan.features[index] === "visible" ||
                        plan.features[index]?.length > 0 ||
                        plan.features[index] === true
                    );
                });
            };
        },
    },
};
</script>

<style scoped lang="scss">
@media (max-width: 800px) {
    .after_success_payment_message {
        padding: 13px !important;
        height: auto !important;

        i {
            width: 30px !important;
        }
    }
}

.table_intro .have_to_be_logged_in {
    width: fit-content;
    margin: auto;
    margin-top: 30px;
    display: flex;
    flex-direction: column;
    gap: 5px;
    background-color: #EFF6FF;
    padding: 15px 30px;
    border-radius: 6px;

    p,
    a {
        color: #1E40AF;
        font-weight: 400;
        font-size: 14px;
    }

    a {
        text-decoration: underline;
    }
}

.swiper-container {
    overflow-x: hidden;
    padding-bottom: 30px;
}

.toggle-container2 {
    opacity: 0;
    transform: translate(-200px, 0);
}

.toggle-container {
    display: flex;
    justify-content: center;
    background-color: white;
    width: fit-content;
    margin: auto;
    border-radius: 12px;
    border: 1px solid #e9e9e9;
    margin-bottom: 48px;
    opacity: 0;
    transform: translate(-200px, 0);
}

.toggle-container .toggle-discount {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.toggle-container .discount-box {
    background-color: #34d399;
    border-radius: 30px;
    padding: 4px 5px 2px 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    font-weight: 800;
    line-height: 100%;
    color: white;
}

.toggle-container button {
    padding: 8px 33px;
    border: none;
    cursor: pointer;
    font-size: 14px;
    color: #212541;
    border-radius: 12px;
    transition: 0.3s;
    font-weight: 500;
}

.toggle-container button.active {
    background: linear-gradient(90deg,
            #f93c34 0%,
            #d73c78 47.28%,
            #c41f5f 75.15%);
    color: white;
    transform: scale(1.03);
}

.pricing-layout {
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: flex-start;
    background-color: white;
    opacity: 0;
    transform: translate(0, 100px);
    padding: 0 0 0 24px;
    position: relative;
}

.features-column {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding-right: 20px;
    margin-top: 65px;
}

.feature-item {
    padding: 12.5px 0;
    color: #6b6f8c;
    white-space: nowrap;
    font-size: 14px;
    height: 46px;
}

.feature-item.disabled {
    color: #bababa;
}

.feature-item.price-per-month {
    padding: 10px 0;
    margin-top: 27px;
    white-space: nowrap;
    color: #404355;
    font-weight: 800;
}

.pricing-container {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    height: 100%;
}

.pricing-card {
    padding: 24px;
    border-radius: 10px;
    text-align: center;
    transition: transform 0.3s, box-shadow 0.3s;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background-color: white;
}

.pricing-card h2 {
    color: #f93c34;
    font-weight: 800;
    font-size: 20px;
    margin-bottom: 10px;
    white-space: nowrap;
}

.pricing-card .top_badge {
    background: linear-gradient(90deg,
            #f93c34 0%,
            #d73c78 47.28%,
            #c41f5f 75.15%);
    color: white;
    border-radius: 17px;
    padding: 0 6px;
    padding-top: 5px;
    padding-bottom: 3px;
    position: absolute;
    top: 0;
    font-size: 14px;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 14px;
    font-weight: 800;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 22px;
}

.popular {
    transform: translateY(-15px);
    height: 102.5%;
    min-width: 210px;
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
    background: white;
}

.popular a.table_plan_btn {
    color: white;
}

a.table_plan_btn {
    .tooltip {
        pointer-events: none;

        @media (max-width: 600px) {
            left: 41% !important;
        }
    }
}

a.table_plan_btn:hover {
    .tooltip {
        opacity: 1 !important;
    }
}

.popular a.table_plan_btn::before {
    background: transparent;
}

.table_intro {
    text-align: center;
    padding-bottom: 50px;
    max-width: 1100px;
    margin-left: auto;
    margin-right: auto;
    opacity: 0;
    transform: translate(200px, 0);
}

.table_intro .plan_table_text_title {
    width: 100%;
    max-width: none;
    font-family: "Fontfabric";
    font-size: 54px;
    font-style: normal;
    font-weight: 800;
    line-height: 65px;
    background: linear-gradient(90deg,
            #f93c34 30%,
            #d73c78 47.28%,
            #c41f5f 75.15%);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    margin-bottom: 19px;
}

.discount_text {
    background: linear-gradient(90deg,
            #f93c34 30%,
            #d73c78 47.28%,
            #c41f5f 75.15%);
    color: white;
    border-radius: 17px;
    -webkit-text-fill-color: white;
    padding: 5px;
    padding-top: 8px;
    font-size: 50px;

    @media (max-width: 1000px) {
        white-space: nowrap;
        font-size: 30px;
    }
}

.table_intro .plan_table_text_subtitle {
    font-family: "Fontfabric";
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 28px;
    color: #6b6f8c;
}

.table_intro .plan_table_text_subtitle .highlight_text {
    font-weight: 600;
    color: #f93c34;
}

.plan_table_text_check_wrapper {
    display: flex;
    gap: 16px;
    justify-content: center;
    margin-top: 26px;
}

.table_intro .plan_table_text_check_wrapper .plan_table_text_check {
    font-weight: 500;
    font-size: 14px;
    color: #6b6f8c;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 4px;
}

.table_outro {
    text-align: center;
    padding-top: 70px;
}

.table_outro .title {
    font-size: 22px;
    font-weight: 800;
    color: #212541;
}

.table_outro .link {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    padding-top: 14px;
    margin: auto;
    position: relative;
    text-decoration: none;
}

.table_outro .link::after {
    content: "";
    position: absolute;
    left: 0;
    bottom: 0;
    width: 88%;
    height: 2px;
    background: linear-gradient(90deg,
            #f93c34 0%,
            #d73c78 47.28%,
            #c41f5f 75.15%);
}

.price span.discount-price {
    font-size: 20px;
    text-decoration: line-through;
    -webkit-text-fill-color: #6B6F8C;
    background: transparent;
    text-decoration-color: #6B6F8C;

}

.price sup.discount-price {
    text-decoration: line-through;
    font-size: 16px;
    -webkit-text-fill-color: #6B6F8C;
    background: transparent;
    text-decoration-color: #6B6F8C;
}

.table_outro .link span {
    font-size: 20px;
    font-weight: 800;
    background: linear-gradient(90deg,
            #f93c34 0%,
            #d73c78 47.28%,
            #c41f5f 75.15%);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

.table_outro .arrow_right {
    transition: all 0.2s ease-in-out;
    width: 23px;
    height: 23px;
    flex-shrink: 0;
    border-radius: 38px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #faefef;
    transition: all 0.2s ease-in-out;
    padding: 3px;
}

@media only screen and (max-width: 1000px) {
    .table_intro .plan_table_text_title {
        font-size: 28px;
        line-height: normal;
    }

    .table_intro .plan_table_text_subtitle {
        font-size: 16px;
        line-height: normal;
    }

    .plan_table_text_check_wrapper {
        flex-direction: column;
        gap: 0;
    }
}

.price {
    font-family: "Fontfabric";
    font-size: 36px;
    font-style: normal;
    font-weight: 800;
    margin: 0 auto;
    margin-top: 24px;
    background: linear-gradient(90deg,
            #f93c34 20%,
            #d73c78 47.28%,
            #c41f5f 75.15%);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

.price sup {
    font-size: 0.6em;
    background: linear-gradient(90deg,
            #f93c34 0%,
            #d73c78 47.28%,
            #c41f5f 75.15%);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

.pricing-card .features-container {
    border-radius: 12px;
    overflow: hidden;
    background-color: #fff6f6;
}

.feature-status {
    padding: 12.5px 0;
    color: #f93c34;
    display: flex;
    align-items: center;
    min-height: 46px;
    justify-content: center;
    font-size: 14px;
    height: 46px;
}

.feature-status.feature-status-visible {
    height: 46px;
}

.mobile-feature-status {
    color: #6b6f8c;
    padding: 10px 0;
    width: fit-content;
    display: flex;
    gap: 6px;
    text-align: left;
}

.mobile-feature-status.disabled {
    color: #bababa;
}

.mobile-feature-status svg {
    color: #f93c34;
    height: 20px;
    width: 20px;
}

a.table_plan_btn .arrow_right {
    transition: all 0.2s ease-in-out;
    width: 23px;
    height: 23px;
    flex-shrink: 0;
    border-radius: 38px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #faefef;
    transition: all 0.2s ease-in-out;
    padding: 4px;
}

a.table_plan_btn {
    display: inline-flex;
    height: 58px;
    padding: 13px 22px 13px 22px;
    font-size: 14px;
    font-weight: 800;
    max-width: 158px;
    justify-content: center;
    align-items: center;
    gap: 7px;
    width: fit-content;
    flex-shrink: 0;
    border-radius: 58px;
    font-weight: 800;
    text-decoration: none;
    color: #ce2e6c;
    position: relative;
    background: linear-gradient(90deg,
            #f93c34 0%,
            #d73c78 47.28%,
            #c41f5f 75.15%);
}

a.table_plan_btn::before {
    content: "";
    position: absolute;
    top: 2px;
    left: 2px;
    right: 2px;
    bottom: 2px;
    background: white;
    border-radius: 55px;
    z-index: 0;
}

a.table_plan_btn span {
    position: relative;
    z-index: 1;
}

a.table_plan_btn:hover {
    background: linear-gradient(90deg,
            #f93c34 0%,
            #d73c78 47.28%,
            #c41f5f 75.15%);
    color: white;
}

a.table_plan_btn:hover .arrow_right {
    transform: translate(0) !important;
}

a.table_plan_btn:hover::before {
    background: transparent;
}

.swiper-wrapper {
    max-width: 260px;
    position: relative;
}

.swiper-pagination {
    bottom: 0 !important;
}

.mobile-pricing-layout {
    width: calc(100% + 15px);
    overflow: visible;
    height: fit-content;
    position: relative;
}

.mobile-pricing-layout .swiper-slide {
    width: 100%;
    height: auto;
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
    padding: 26px;
}

.mobile-pricing-layout {
    display: none;
}

@media (max-width: 1024px) {
    .mobile-pricing-layout {
        display: block;
    }

    .pricing-layout {
        display: none;
    }
}

@media (max-width: 740px) {
    a.table_plan_btn {
        width: 100%;
        max-width: none;
    }

    .toggle-container {
        margin-bottom: 21px;
        font-size: 12px;
    }

    .toggle-container button {
        font-size: 12px;
    }

    .toggle-container .discount-box {
        font-size: 8px;
    }
}

.mobile-pricing-tabs {
    display: flex;
    justify-content: center;
    border: 1px solid #e9e9e9;
    margin: 0 -15px 31px -15px;
    width: calc(100% + 15px);
}

.tab-item {
    padding: 19px 15px;
    background: white;
    cursor: pointer;
    transition: background 0.3s, color 0.3s;
    width: 100%;
    text-align: center;
    display: flex;
    justify-content: center;
    white-space: nowrap;
    font-size: 12px;
}

.tab-item.active-tab {
    background: linear-gradient(90deg,
            #f93c34 0%,
            #d73c78 47.28%,
            #c41f5f 75.15%);
    color: white;
    font-weight: bold;
}
</style>
